exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-red[data-v-54d0f062] {\n  border: 1px solid #f00;\n}\n.disable[data-v-54d0f062] {\n  pointer-events: none;\n}\n", ""]);

// exports
